import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../helpers';
import { TREATMENT_PLANS_V2_API_BASE } from '../../constants';

import type { IReferral } from '../../../../pages/common';
import type {
  GetTreatmentPlanV3ReferralPagePayload,
  CreateTreatmentPlanV3ReferralPayload,
  UpdateTreatmentPlanV3ReferralPayload,
  DeleteTreatmentPlanV3ReferralPayload,
} from './types';

export function createTreatmentPlanV3ReferralThunks() {
  return {
    getTreatmentPlanV3ReferralPage: getTreatmentPlanV3ReferralPage(),
    createTreatmentPlanV3Referral: createTreatmentPlanV3Referral(),
    updateTreatmentPlanV3Referral: updateTreatmentPlanV3Referral(),
    deleteTreatmentPlanV3Referral: deleteTreatmentPlanV3Referral(),
  };
}

function getTreatmentPlanV3ReferralPage() {
  return createAsyncThunk<IReferral[], GetTreatmentPlanV3ReferralPagePayload>(
    'treatmentPlanV3/getTreatmentPlanV3ReferralPage',
    async ({ treatmentPlanId, getAccessTokenSilently }) =>
      fetchWrapper.get({
        url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/referrals/`,
        getAccessTokenSilently,
      }),
  );
}

function createTreatmentPlanV3Referral() {
  return createAsyncThunk<IReferral, CreateTreatmentPlanV3ReferralPayload>(
    'treatmentPlanV3/createTreatmentPlanV3Referral',
    async ({ treatmentPlanId, data, getAccessTokenSilently }) =>
      fetchWrapper.post(
        {
          url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/referrals/`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function updateTreatmentPlanV3Referral() {
  return createAsyncThunk<IReferral, UpdateTreatmentPlanV3ReferralPayload>(
    'treatmentPlanV3/updateTreatmentPlanV3Referral',
    async ({ treatmentPlanId, referralId, data, getAccessTokenSilently }) =>
      fetchWrapper.patch(
        {
          url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/referrals/${referralId}/`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function deleteTreatmentPlanV3Referral() {
  return createAsyncThunk<void, DeleteTreatmentPlanV3ReferralPayload>(
    'treatmentPlanV3/deleteTreatmentPlanV3Referral',
    async ({ treatmentPlanId, referralId, getAccessTokenSilently }) => {
      await fetchWrapper.delete({
        url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/referrals/${referralId}/`,
        getAccessTokenSilently,
      });
    },
  );
}
